<template>
  <div class="LoginForm">
    <el-form :model="form" ref="loginForm" :rules="rules" inline size="large">
      <div>
        <h3>{{ title }}</h3>
      </div>
      <el-form-item prop="account">
        <el-input
          prefix-icon="el-icon-user-solid"
          v-model="form.account"
          placeholder="아이디"
          ref="account"
          @keyup.enter.native="submit"
          class="m-auto"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          prefix-icon="el-icon-lock"
          v-model="form.password"
          placeholder="비밀번호"
          ref="password"
          @keyup.enter.native="submit"
          class="m-auto"
        ></el-input>
      </el-form-item>
      <div class="rememberId relative">
        <el-checkbox v-model="rememberId" size="large">아이디기억하기</el-checkbox>
      </div>
      <div class="submit m-auto">
        <el-button
          type="primary"
          size="large"
          @click="submit()"
          class="submit"
        >{{ $t('button.login') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VueCookies from 'vue-cookies'
import store from "store";

var validate = (value, callback, message) => {
  if (value === "") {
    callback(new Error(message));
  } else {
    callback();
  }
};

export default {
  name: "LoginForm",
  data() {
    var validateId = (rule, value, callback) =>
      validate(value, callback, "아이디를 입력해주세요");
    // var validatePass = (rule, value, callback) =>
    //   validate(value, callback, "비밀번호를 입력해주세요");
    return {
      form: {
        account: "",
        password: ""
      },
      rules: {
        account: [{ validator: validateId, trigger: "blur" }],
        // password: [{ validator: validatePass, trigger: "blur" }]
      },
      rememberId: false
    };
  },
  props: ["title"],
  created() {    
    if (!VueCookies.get("refreshed")) {
      VueCookies.set("refreshed", true)
      location.reload(true);
    } else {
      setTimeout(() => {
        this.$nextTick(() => this.init());
      }, 100);
    }
  },
  methods: {
    ...mapActions(["setSignInStatus", "setToken", "setUserData", "setExpireTime"]),
    init() {
      if (store.get("rememberId")) {
        this.form.account = store.get("rememberId");
        this.rememberId = true;
        this.$refs.password.focus();
      } else {
        this.$refs.account.focus();
      }
    },
    submit() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return;
        this.doLogin();
      });
    },
    doLogin() {
      this.api.doLogin(this.form).then(res => {
        if (res.error !== this.system.noError) {    
          if (res.error === 6) {
            //패스워드 초기화 되어 있음
            // this.$router.push("/password");
            this.$emit('setPassword', this.form.account);
            return;
          } else {
            this.$message.error({
              message: "로그인에 실패하였습니다.",
              offset: 250
            });
            return;
          }
        }
        this.login(res);
      });
    },
    login(data) {
      if (this.rememberId) {
        store.set("rememberId", data.data.account);
      } else {
        store.remove("rememberId");
      }
      // 쿠키 기본 저장시간은 10시간으로 설정
      var expireTime = this.util.getDateString(this.util.addPeriod(10, 'h', false), false);
      // var expireTime = this.util.getDateString(this.util.addPeriod(40, 's', false), false); // test
      this.setSignInStatus(true);
      this.setToken(data.token);
      this.setUserData(data.data);
      this.setExpireTime(expireTime);
      this.$emit("finished");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-input,
.submit {
  font-size: 16px;
  font-weight: bold;
  width: 190px;
  // height: 30px;
}
div.submit {
  margin-top: 6px;
}
.rememberId {
  width: 146px;
  left: 13px;
}
</style>